import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { SEO_WEB_URL } from '../../contexts/Apilinks';
let siteUrl = SEO_WEB_URL;

const SEO = ({title, description, image, slug, children}) => {
 let seoTitle = title !== undefined ? title : <> {`World's most popular books, author interviews, book video trailers, promotion and author publicity`}</>;
 let seoDescription = description !== undefined ? description : <>{`Search the world's most popular books, author interviews, and view book video trailers. Browse through a variety of genres such as fiction, self-help, children's books, personal development, business, and motivational books. Find today's book of the day, book of the week, and book of the month. Vote for book cover contests. Book advertisement  and promotion opportunities provided for authors`} </>;
 let seoImage = image !== undefined ? image : "";
 let seoSlug = slug !== undefined ? slug : "/";

  return ( <HelmetProvider>
    <Helmet htmlAttributes={{lang: `en`}}>
      <title>{seoTitle}</title>
      <meta name='description' content={seoDescription} />

      <link rel='canonical' href={`${siteUrl}${seoSlug}`} />
      <meta name='twitter:card' content='summary' />
      <meta name="twitter:title" content={`${seoTitle}`} />
      <meta name="twitter:image" content={`${seoImage}`} />
      <meta name="twitter:description" content={`${seoDescription}`} />
      <meta name='og:title' content={seoTitle} />
      <meta name='og:description' content={seoDescription}/>
      <meta name='og:image' content={`${seoImage}`} />
      <meta name='og:type' content='website' />
      <meta name='og:url' content={`${siteUrl}`}/>
      <meta name='og:site_name' content={siteUrl} />


      {/* <!-- Google / Search Engine Tags --> */}
    <meta itemprop="name" content={seoTitle} />
    <meta itemprop="description" content={seoDescription} />
    <meta itemprop="image" content={seoImage} />

    {/* <!-- Facebook Meta Tags --> */}
    <meta property="og:url" content={siteUrl} />
    <meta property="og:type" content="website" />
    <meta property="og:title" content={seoTitle} />
    <meta property="og:description" content={seoDescription} />
    <meta property="og:image" content={seoImage} />

    {/* <!-- Twitter Meta Tags --> */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={seoTitle} />
    <meta name="twitter:description" content={seoDescription} />
    <meta name="twitter:image" content={seoImage} />

      {children}
    </Helmet>
  </HelmetProvider>);
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  slug: PropTypes.string,
  children: PropTypes.node,
};

export default SEO;